import { z } from 'zod';

export const invoicePaidPlanSchema = z.object({
  idInvoicePaidPlan: z.number().default(-1),
  idInvoice: z.number().default(-1),
  PaidValue: z.number().default(0),
  PaidDate: z.string().default(new Date().toISOString().split('T')[0]),
  wasPaid: z
    .union([z.boolean(), z.number().transform(val => Boolean(val))])
    .transform(val => Boolean(val))
    .default(false),
});
export type IInvoicePaidPlan = z.infer<typeof invoicePaidPlanSchema>;
